import { buildConfig } from '@refract-cms/core';
import { AboutSchema } from './schemas/about-schema';
import { BioSchema } from './schemas/bio-schema';
import { CenturySchema } from './schemas/century-schema';
import { ContactSchema } from './schemas/contact-schema';
import { HomeSchema } from './schemas/home-schema';
import { fileSystemImagePluginConfig } from './plugins/file-system-image';

export const config = buildConfig({
  schema: [BioSchema, CenturySchema, HomeSchema, AboutSchema, ContactSchema],
  // plugins: [fileSystemImagePluginConfig],
});
